import { Injectable } from '@angular/core';
import { PocketbaseService } from './pocketbase.service';
import { Achievement } from '../interfaces/achievementInterface';
import { RecordModel } from 'pocketbase';

@Injectable({
  providedIn: 'root'
})
export class AchievementService {

  constructor(private readonly pocketbaseService: PocketbaseService) { }

  async getAchievements(): Promise<Achievement[]> {
    if (this.pocketbaseService.pb.authStore.model != null) {
      const userId = this.pocketbaseService.pb.authStore.model['id'];

      if (!userId) {
        throw new Error('Not logged in');
      }

      const records = await this.pocketbaseService.pb.collection('achievements').getFullList<Achievement>({
          filter: this.pocketbaseService.pb.filter("user = {:userId}", {userId}),
          sort: '-created',
          expand: 'exam'
        });
  
      return records;
    }

    throw new Error('Not logged in');
  }

  async getCorrectStreakProgress(): Promise<{current: number, next: number}> {
    if (this.pocketbaseService.pb.authStore.model != null) {
      const userId = this.pocketbaseService.pb.authStore.model['id'];

      if (!userId) {
        throw new Error('Not logged in');
      }

      const record = await this.pocketbaseService.pb.send<{current: number, next: number}>('/achievements/correct-streak', {method: 'GET'});

      return record;
    }

    throw new Error('Not logged in');
  }

  async claimTestCompletionAchievement(examId: string): Promise<{achievement: Achievement, nextCount?: number} | undefined> {
    if (this.pocketbaseService.pb.authStore.model != null) {
      const userId = this.pocketbaseService.pb.authStore.model['id'];

      if (!userId) {
        throw new Error('Not logged in');
      }

      try {
        const achievement = await this.pocketbaseService.pb.send<{achievement: Achievement, nextCount?: number}>('/achievements/test-completions', {method: 'POST', body: {
          exam_id: examId,
        }})
    
        return achievement;
      } catch (error) {
        return undefined;
      }
    }

    throw new Error('Not logged in');
  }

  async claimStreakAchievement(): Promise<{achievement: Achievement, nextCount?: number} | undefined> {
    if (this.pocketbaseService.pb.authStore.model != null) {
      const userId = this.pocketbaseService.pb.authStore.model['id'];

      if (!userId) {
        throw new Error('Not logged in');
      }

      try {
        const achievement = await this.pocketbaseService.pb.send<{achievement: Achievement, nextCount?: number}>('/achievements/correct-streak', {method: 'POST'})
    
        return achievement;
      } catch (error) {
        return undefined;
      }
    }

    throw new Error('Not logged in');
  }
}
